import { MyopMessages } from "../../common/MyopMessages";
import {ChangeTextMessage} from "../../messages";
import {BaseMessageHandler} from "../../common";
import {getElementsByRef} from "../../common/messageHandlers/helpers";

export class ChangeTextHandler extends BaseMessageHandler<ChangeTextMessage> {
  
    messageType = MyopMessages.ChangeTextMessage;
    
    executor = (event: ChangeTextMessage) => {
        const items = getElementsByRef(event.ref, document);
        items.forEach(item => {
            // @ts-ignore
            item.textContent = event.content;
        })
    }
}
